import React, { lazy } from 'react';
import { Phone, Mail, MapPin, Clock } from 'lucide-react';
import { ContactForm } from '../components/ContactForm';
export function Contact() {
  return <div className="pt-10" data-id="element-218" data-mp="1bugex8784w4s">
      <section className="bg-blue-900 text-white py-20" data-id="element-219" data-mp="1qpwf7uyedo9m">
        <div className="container-custom text-center" data-id="element-220" data-mp="1qna79u7lh6qv">
          {/* Logo */}
          <img src="https://cdn.magicpatterns.com/uploads/kiYzPUUhowPGrQvZZU5M1J/G_(1).png" alt="Brixen Consulting" className="h-20 w-auto mx-auto mb-8" data-id="element-221" data-mp="1lqt9076olc02" />
          <h1 className="text-4xl font-bold mb-6" data-id="element-222" data-mp="t35th6k9pbka">Get in Touch</h1>
          <p className="text-xl text-blue-100 max-w-2xl mx-auto" data-id="element-223" data-mp="17qqt2qhxosng">
            Ready to start your business journey? Contact us today for a free
            consultation.
          </p>
        </div>
      </section>

      <section className="py-20 bg-gray-50" data-id="element-224" data-mp="f965i1urmeb9">
        <div className="container-custom" data-id="element-225" data-mp="f7uzdvdukugz">
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-12" data-id="element-226" data-mp="abweihrq9ulb">
            {/* Contact Info Sidebar */}
            <div className="lg:col-span-4 space-y-8" data-id="element-227" data-mp="15edp1h2et2jn">
              <div className="bg-white p-8 rounded-xl shadow-sm border border-gray-100" data-id="element-228" data-mp="19h0mbxhunfo8">
                <h2 className="text-xl font-bold text-gray-900 mb-6" data-id="element-229" data-mp="19enxd0doc51o">
                  Contact Information
                </h2>
                <div className="space-y-6" data-id="element-230" data-mp="1j7d5bla0n0s9">
                  <div className="flex items-start" data-id="element-231" data-mp="1j621xmkhfv1o">
                    <Phone className="h-6 w-6 text-blue-800 mr-4 shrink-0 mt-1" data-id="element-232" data-mp="mh2rc0wfeh6b" />
                    <div data-id="element-233" data-mp="qhwh6ztfi61u">
                      <p className="text-sm font-medium text-gray-500 mb-1" data-id="element-234" data-mp="qhef3mk34xm0">
                        Phone
                      </p>
                      <a href="tel:+971042766249" className="text-lg font-semibold text-gray-900 hover:text-blue-800 transition-colors" data-id="element-235" data-mp="vfxypgb7hxb7">
                        +971 04 276 6249
                      </a>
                    </div>
                  </div>

                  <div className="flex items-start" data-id="element-236" data-mp="2bxc1e0mmny6f">
                    <Mail className="h-6 w-6 text-blue-800 mr-4 shrink-0 mt-1" data-id="element-237" data-mp="1m627xe1827os" />
                    <div data-id="element-238" data-mp="1h920ozsmyyw3">
                      <p className="text-sm font-medium text-gray-500 mb-1" data-id="element-239" data-mp="1h7qy33axfx6k">
                        Email
                      </p>
                      <a href="mailto:info@brixenconsulting.com" className="text-lg font-semibold text-gray-900 hover:text-blue-800 transition-colors" data-id="element-240" data-mp="1w36wtlmgch9a">
                        info@brixenconsulting.com
                      </a>
                    </div>
                  </div>

                  <div className="flex items-start" data-id="element-241" data-mp="1d7qjnintvlzi">
                    <MapPin className="h-6 w-6 text-blue-800 mr-4 shrink-0 mt-1" data-id="element-242" data-mp="18fysp70rfe8u" />
                    <div data-id="element-243" data-mp="18dvu3yljkcsi">
                      <p className="text-sm font-medium text-gray-500 mb-1" data-id="element-244" data-mp="kq4g8qkcrrp4">
                        Office Address
                      </p>
                      <p className="text-gray-900" data-id="element-245" data-mp="fqi4ymo34liy">
                        Iris Bay Tower, 2204,
                        <br data-id="element-246" data-mp="2rdv2or02031o" />
                        Business Bay,
                        <br data-id="element-247" data-mp="2w5v9n3ejjw7r" />
                        Dubai, United Arab Emirates
                      </p>
                    </div>
                  </div>

                  <div className="flex items-start" data-id="element-248" data-mp="2hedxsbsmlt6r">
                    <Clock className="h-6 w-6 text-blue-800 mr-4 shrink-0 mt-1" data-id="element-249" data-mp="2mes9q4xclna2" />
                    <div data-id="element-250" data-mp="3a5e62yxzpj48">
                      <p className="text-sm font-medium text-gray-500 mb-1" data-id="element-251" data-mp="3a661a8nodetz">
                        Business Hours
                      </p>
                      <p className="text-gray-900" data-id="element-252" data-mp="3f1v36in637tg">
                        Monday – Friday | 9:00 AM – 6:00 PM (GST)
                      </p>
                    </div>
                  </div>
                </div>
              </div>

              {/* Google Maps Embed */}
              <div className="rounded-xl overflow-hidden border border-gray-200 shadow-sm" data-id="element-253" data-mp="1pnpzd7ic71ws">
                <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3612.5676089668!2d55.37799731544386!3d25.117270983929!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3e5f654b4e720c6f%3A0x7e3b3b3b3b3b3b3b!2sDubai%20Silicon%20Oasis!5e0!3m2!1sen!2sae!4v1700000000000!5m2!1sen!2sae" width="100%" height="256" style={{
                border: 0
              }} allowFullScreen loading="lazy" referrerPolicy="no-referrer-when-downgrade" title="Brixen Consulting Office Location" className="w-full h-64" data-id="element-254" data-mp="1tro0tov4wot0"></iframe>
              </div>
            </div>

            {/* Contact Form */}
            <div className="lg:col-span-8" data-id="element-255" data-mp="2ew2gmvvk5l39">
              <div className="bg-white rounded-xl shadow-sm border border-gray-100 overflow-hidden" data-id="element-256" data-mp="2ezgg9wcu7g70">
                <div className="p-8 border-b border-gray-100" data-id="element-257" data-mp="17h7gsvnx9wua">
                  <h2 className="text-2xl font-bold text-gray-900" data-id="element-258" data-mp="13gdqxwqx67yr">
                    Send us a Message
                  </h2>
                  <p className="text-gray-600 mt-2" data-id="element-259" data-mp="3f3h8t6bk4ypi">
                    Fill out the form below and we'll get back to you shortly.
                  </p>
                </div>
                <div className="p-0" data-id="element-260" data-mp="3o4fia44rlyfh">
                  <ContactForm data-id="element-261" data-mp="3swp1l1bdk08s" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>;
}